import { render } from "./CompBottomContent.vue?vue&type=template&id=5cc2204a&scoped=true"
import script from "./CompBottomContent.vue?vue&type=script&lang=js"
export * from "./CompBottomContent.vue?vue&type=script&lang=js"

import "./CompBottomContent.vue?vue&type=style&index=0&id=5cc2204a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc2204a"]])

export default __exports__